import {
  IUserProfilePatchPayload,
  IUserProfilePostPayload,
  UserProfileService,
} from '@/app/services/user-profile'
import { ErrorResponse, IApiIndividualResponse } from '@/types/api'
import { IProfile } from '@/types/profile'

import { UseMutationOptions, useMutation, useQueryClient } from 'react-query'

export function useUserProfileMutation(
  profileId: string,
  options: Omit<
    UseMutationOptions<
      IApiIndividualResponse<IProfile>,
      ErrorResponse,
      IUserProfilePatchPayload | IUserProfilePostPayload
    >,
    'mutationKey' | 'mutationFn'
  > = {}
) {
  const queryClient = useQueryClient()

  return useMutation<
    IApiIndividualResponse<IProfile>,
    ErrorResponse,
    IUserProfilePatchPayload | IUserProfilePostPayload
  >(
    profileId
      ? UserProfileService.getPatchPath(profileId)
      : UserProfileService.getPostPath(),
    profileId
      ? (payload) => UserProfileService.patchUserProfile(profileId, payload)
      : UserProfileService.postUserProfile,
    {
      ...options,
      onSuccess: async (...args) => {
        await queryClient.invalidateQueries(UserProfileService.GET_PATH)

        if (options.onSuccess) {
          return options.onSuccess(...args)
        }
      },
    }
  )
}
